import { PureConnect, React } from '../../react';
import { INote, INoteShared, IParticipant, IUsergroup, isSharedNote } from '../../types';
import { categoriesResource } from '../categories/resource';
import { notesEditor } from '../notes/resource';
import { selectors } from '../../meta/selectors';
import cx from './style.less';
import { participantsResource } from '../../participant/resource';
import { usergroupResource } from '../../usergroup/resource';
import { notesSharedEditor } from '../noteshared/resource';

function mapParticipantsNames(participantIds: string[], allparticipants: IParticipant[]) {
    let participantstring='';

    const participants = allparticipants.qWhere((item) => participantIds ? participantIds.qIncludes(item.id):false);
    participantstring = participants && participants.qAny()? 
        `Gedeeld met ${participants.map((x) => {
            return x.name;
        }).join(', ')}`:        
        '';
    return participantstring;
}

function mapGroups(emailParticipantGroupIds: string[], allparticipantgroups: IUsergroup[]) {
    let groupsstring='';
    const groups = allparticipantgroups.qWhere((item) => emailParticipantGroupIds ? emailParticipantGroupIds.qSelect((itm)=>parseInt(itm)).qIncludes(item.id):false);    
    groupsstring =  
    groups && groups.qAny() ?
        `Gedeeld met ${groups.map((x) => {
            return x.name;
        }).join(', ')}` :         
        '';
    return groupsstring;
}

export default PureConnect<{ item: INote, participant: IParticipant, visible?: boolean }>('DataItemNote')(
    (state, props) => ({
        categories: categoriesResource.selectors.items(state),
        docId: selectors.docId(state),
        pageId: selectors.pageId(state),
        allparticipants: participantsResource.selectors.items(state).qSelect((item) => item as IParticipant),
        allparticipantsgroups: usergroupResource.selectors.items(state).qSelect((item) => item as IUsergroup), 
    }),
    (dispatch) => ({
        selectNote: (note: INote| INoteShared) => {
            if (!isSharedNote(note)) {
                dispatch(notesEditor.actions.READ({ item: note }));       
            } else {
                dispatch(notesSharedEditor.actions.READ({ item: note })); 
            }
        },
    }),
    ({ item, participant, allparticipants, allparticipantsgroups, visible, item: { text, categoryId }, categories, selectNote }) => {
        const onClickItem = () => {
            selectNote(item);
        };
        
        const onKeyDownNotTab = (ev: React.KeyboardEvent<HTMLLIElement>) => {
            if (ev.key==='Enter') {
                onClickItem();
            }
        };

        const color = categories.reduce((catColor, category) => {
            catColor = (categoryId === category.id) ? category.color : catColor;
            return catColor;
        }, '#efefef');

        return ( 
            <li className={cx('data-item')} tabIndex={visible? -1: 0} onKeyDown={(event) => onKeyDownNotTab(event)} onClick={onClickItem}>
                <div className={cx('vraagofnotitie')}> 
                    <span className={cx('vraagofnotitie-status')} style={{backgroundColor:color}}></span>
                    <div className={cx('icon-left-container')}>
                        <span className={cx('icon-container', item.isquestion? 'question' : 'message')}></span>
                    </div>
                    <div className={cx('text-container')}>
                        <div className={cx('text-container_main')}>{item.text}</div>
                        <div className={cx('text-container_author')}>
                            <span className={cx('icon-container', 'pencil')}></span>
                            <span className={cx('autho-name')}>{participant?participant.name : ''}</span>
                        </div>
                    </div>
                    <div className={cx('icon-right-container')}>
                        {item&&item.noteParticipantsIDs&&item.noteParticipantsIDs.length?<span title={mapParticipantsNames(item.noteParticipantsIDs, allparticipants)} className={cx('icon-shared')}></span> : null}
                        {item&&item.noteParticipantGroupIDs&&item.noteParticipantGroupIDs.length?<span title={mapGroups(item.noteParticipantGroupIDs, allparticipantsgroups)} className={cx('icon-shared_multiple')}></span> : null}
                    </div>
                </div>
            </li>
        );
    },
);



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/dataitem/index.tsx